export class Region {
  constructor(
    public name: string,
    public code: string = '',
    public countries: string[] = [],
    public id?: number,
    public disabled?: boolean
  ) {
    if (!disabled) {
      this.disabled = false;
    }
  }
}

export class CityRegion {
  constructor(
    public name: string,
    public code: string,
    public subTerritoriesCount?: number,
    public disabled?: boolean,
    public loading?: boolean
  ) {}
}
